/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import Debounce from "../../../CommonMethods/Debounce";
import { useCallback } from "react";
import { useDispatch ,useSelector} from "react-redux";
import { useGetProvidersQuery } from "../../../features/providerSlice";
import { setProviderCurIndex,toggleProviderRowSelection,selectAllProviderRows,addAllProviderInitially,fillEmptyProviderArray,searchProviderReducer,searchProviderValSetter } from "../providersSlice";
import { useLocation } from "react-router-dom";
export default function DropdownSearchForProvider({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    index,

}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()

    const selectedUsers=useSelector(state=>state?.providersSelect?.selectedUsers)
    const curIndex=useSelector(state=>state?.providersSelect?.selectedUsers?.curIndex)
    const checkedArr= useSelector(state=>state?.providersSelect?.selectedUsers?.checkedArr)
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [queryParams,setQueryParams] = useState('')
    
    let {data,isFetching,isLoading,status}=useGetProvidersQuery(selectedUsers?.searchVal.trim()===''?'dropdown=true':`search=${encodeURIComponent(selectedUsers?.searchVal.trim())}&dropdown=true`)
    const [suggestions,setSuggestions] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null);
    const [isOpen, setisOpen] = useState(false);


    function handleIsCheckedAll(event){
        dispatch(selectAllProviderRows([event.target.checked,data?.data]))
    }


    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });

    
    useEffect(()=>{
        if(selectedUsers.searchVal.trim()==='')
        {
            setQueryParams(`dropdown=true`)
            dispatch(searchProviderValSetter(['']))
        }

    }, [selectedUsers.searchVal])

    useEffect(()=>{
        isFetching?setDisplayEmptyMsg(''):''
    },[isFetching])

    const handleChange = (val) => {
        if (val.trim() !== '') {
            setQueryParams(`search=${val.trim()}&dropdown=true`)

        }
        dispatch(searchProviderValSetter([val.trim()]))


    }
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        []
    );
    


    useEffect(() => {
        if (data !== undefined) {
            if (data?.data?.length === 0) {
                setDisplayEmptyMsg('No results found.')
                return

            }
            setDisplayEmptyMsg('')
            selectedUsers?.data?.length === 0 && dispatch(addAllProviderInitially([data?.data]))
            if (checkedArr[0] !== undefined && checkedArr[0][0] === null) {
                dispatch(fillEmptyProviderArray([data?.data]))
            }
            dispatch(searchProviderReducer([data?.data,curIndex]))
        } 
       
        
    },[data])

    useEffect(() => {
        optimizedFn('')
        setSuggestions('')

    }, [isOpen]);

    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button id={'provider_user'} ref={buttonRef} onClick={() => { dispatch(setProviderCurIndex([index])), setisOpen(!isOpen) }} className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p  className={`${(value === "" || value === undefined || value === true) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[99] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        autoComplete={"off"}
                                        id="search-value-provider"
                                        placeholder="Search by ID & Username"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                        onChange={e => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                                        value={suggestions} />
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                            {displayEmptyMsg === ""&&!(((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected")))&&data?.total_count!==0 ? <li className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1 pr-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='id1provider' checked={selectedUsers.isCheckedAll[curIndex]} onChange={(e) => handleIsCheckedAll(e)} className='prevent-click' />
                                    <label htmlFor='id1provider' data-testid='select_all_pro'  className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}>Select All</label>
                                </div>
                                <button data-testid="clear-all" onClick={()=>{dispatch(selectAllProviderRows([false,data?.data]))}} type='button' className={selectedUsers?.checkedArr[curIndex]?.length===0?'hidden':`text-xs font-semibold text-[#008586]`}>
                                    Clear All
                                </button>
                            </li> : <p className="mt-2 text-center">{displayEmptyMsg}</p>}
                        </ul>
                        {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))? <div className=' h-[30px] relative   px-4 xl rounded-lg mt-3 '>
                            <div className='flex justify-center items-center mt-[90px]'>
                                                           
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                                                           
                                                            
                            </div>
                        </div>:<ul>
                            <li>
                            
                                <ul className={`max-h-[399px] overflow-auto scrollbar_gray pr-3`}>
                                    {
                                        data?.data?.map((item, i) => (
                                            <li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                    <input type="checkbox" data-testid={`provider-${index}`} id={i+"provider_user"} onChange={() => dispatch(toggleProviderRowSelection([item?.user_id, data?.data]))} checked={selectedUsers?.checkedArr[curIndex]?.includes(item?.user_id) ? true : false} className=' prevent-click' />
                                                    <label id={i+"provider"} title={item?.user_id + "-" + item?.user_name} htmlFor={i+"provider_user"} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines">{item?.user_id} {item?.user_name}</label>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </li>
                        </ul>}
                    </li>

                </ul>
            </div>
        </>
    )
}
